const fields = {
  title: 'Заголовок',
  signMethod: 'Способ подписания',
  owner: 'Владелец',
  requisite: 'Реквизит',
  company: 'Компания',
  createdAt: 'Создано',
  updatedAt: 'Обновлено'
}

export default {
  title: 'Договоры',

  titles: {
    create: 'Создать договор',
    upload: 'Загрузить существующий договор',
    confirm: {
      remove: 'Подтверждение удаления'
    }
  },

  headers: {
    ...fields
  },

  labels: {
    ...fields
  },

  signMethods: {
    original: 'Оригинал',
    'edo-diadok': 'ЭДО Диадок',
    'edo-sbis': 'ЭДО СБИС',
    copy: 'Копия',
    null: 'Не указан',
    undefined: 'Не указан'
  },

  buttons: {
    attach: 'Прикрепить файл'
  },

  actions: {
    edit: 'Редактировать',
    download: 'Скачать PDF',
    remove: 'Удалить'
  },

  contents: {
    confirm: {
      remove: 'Подтвердите удаление договора'
    }
  },

  tooltips: {
    edit: 'Редактировать файл'
  },

  snackbars: {
    created: 'Договор успешно создан.',
    updated: 'Договор успешно обновлён.',
    removed: 'Договор успешно удалён.'
  }
}
